import { Theme } from '@logto/schemas';
import classNames from 'classnames';
import type { ComponentPropsWithoutRef, KeyboardEvent } from 'react';

import hytchLogoDark from '@/assets/images/hytch/hytch-logo-dark.png';
import hytchLogoLight from '@/assets/images/hytch/hytch-logo-light.jpeg';
import useTheme from '@/hooks/use-theme';

import styles from './index.module.scss';

type Props = Omit<ComponentPropsWithoutRef<'div'>, 'children'> & {
  readonly label?: string;
};

function BrandLogo({ className, label = 'Hytch Auth', onClick, onKeyDown, ...rest }: Props) {
  const theme = useTheme();
  const logo = theme === Theme.Dark ? hytchLogoDark : hytchLogoLight;
  const isInteractive = Boolean(onClick);

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    onKeyDown?.(event);

    if (event.defaultPrevented || !onClick || (event.key !== 'Enter' && event.key !== ' ')) {
      return;
    }

    event.preventDefault();
    event.currentTarget.click();
  };

  return (
    <div
      aria-label={label}
      className={classNames(styles.logo, className)}
      role={isInteractive ? 'button' : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      {...rest}
    >
      <img className={styles.mark} src={logo} alt="" aria-hidden="true" />
      <span className={styles.wordmark}>{label}</span>
    </div>
  );
}

export default BrandLogo;
